import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";
import { formatDateTime } from "@/lib/format";
import { useNavigate } from "react-router-dom";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/notifications"); setItems(r.data); }
    catch { toast.error("Erro ao carregar notificações"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); toast.success("Todas marcadas como lidas"); load(); }
    catch (_e) { void _e; }
  };
  const openItem = async (n) => {
    try { await api.post(`/notifications/${n.id}/read`); } catch (_e) { void _e; }
    if (n.link) navigate(n.link);
  };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <header className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium">Central</p>
          <h1 className="font-heading text-3xl font-bold mt-1">Notificações</h1>
        </div>
        <Button variant="outline" onClick={markAll} className="gap-2" data-testid="mark-all-read-btn">
          <CheckCheck size={15} /> Marcar todas como lidas
        </Button>
      </header>

      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="p-6 space-y-2">{Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-12 rounded" />)}</div>
          ) : items.length === 0 ? (
            <div className="p-12 text-center text-sm text-muted-foreground">
              <Bell className="mx-auto mb-3 text-muted-foreground/50" /> Nenhuma notificação.
            </div>
          ) : (
            <ul className="divide-y">
              {items.map((n) => (
                <li key={n.id}>
                  <button onClick={() => openItem(n)} className="w-full text-left p-4 hover:bg-muted/40 transition-colors flex items-start gap-3" data-testid={`notif-item-${n.id}`}>
                    <span className={`w-2 h-2 mt-2 rounded-full shrink-0 ${n.read ? "bg-muted-foreground/40" : "bg-primary"}`} />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium">{n.title}</p>
                      <p className="text-sm text-muted-foreground">{n.message}</p>
                      <p className="text-xs text-muted-foreground mt-1">{formatDateTime(n.created_at)}</p>
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
